// date-fns specification
export const DATE_FORMAT_STRING = 'dd.MM.yyyy'
export const TIME_FORMAT_STRING = 'HH:mm'
export const DATETIME_FORMAT_STRING = `${DATE_FORMAT_STRING} ${TIME_FORMAT_STRING}`
export const POST_DATE_FORMAT_STRING = 'MMMM d, yyyy'
